<app-tab-form-modal [isModal]="isModal" [showSave]="showSave" [showBack]="showBack">
  <app-base-comments [commentService]="purchaseOrderCommentService" [id]="id" [commentStart]="commentStart">
  </app-base-comments>
</app-tab-form-modal>
